import Vue from 'vue';
import Component from 'vue-class-component';

import Rating from 'common/components/Rating';
import ReviewLikeButton from '../ReviewLikeButton/ReviewLikeButton.vue';

import defaultUserImage from 'common/images/usuario-01.png';

import moment from 'common/deps/moment';

@Component({
  props: {
    reviewProduct: {
      description:
        'with the username who wrote it, the activity reviewed, the satisfaction score and the review body',
      type: Object,
      required: true,
    },
    productType: {
      type: String,
    },
    newBigbox: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Rating,
    ReviewLikeButton,
  },
})
export default class ReviewComponent extends Vue {
  get userProfileImage() {
    if (this.reviewProduct.profile_image !== null) {
      return this.reviewProduct.profile_image;
    }
    return defaultUserImage;
  }

  get defaultUserImageBackground() {
    return defaultUserImage;
  }
  get reviewDate() {
    return moment(this.reviewProduct.date_completed).format('DD/MM/YYYY');
  }

  get reviewData() {
    const { name } = this.reviewProduct.activity;
    return  this.reviewDate ? `${name}  |  ${this.reviewDate}` : name;
  }

  get isBoxTypeReview() {
    return this.$props.productType === 'BoxType';
  }

  get reviewDateDisplay() {
    return this.isBoxTypeReview ? this.reviewData : this.reviewDate;
  }
 }
